<template>
	<section class="recently-added">
    <h2>Recently Added</h2>
    <div>
    <h3>Parametric PCR</h3>
    <p>Author <a>Opentrons</a></p>
    <p>Ut sollicitudin viverra volutpat. Pellentesque aliquam hendrerit tempor. Sed ut leo interdum, porttitor nunc a.</p>
    <a class="view-protocol">View Protocol</a>
    </div>
	</section>
</template>

<script>
  export default {
    name: 'RecentlyAdded'
  }
</script>


// WEBPACK FOOTER //
// RecentlyAdded.vue?027e7110